import {
    ORGANIZATION_SERVICES_QUERY_KEY_ROOT,
    type BuildOrganizationServiceDetailQueryKeyParams,
    type OrganizationServiceDetailQueryKey,
} from '../types';

const buildOrganizationServiceDetailQueryKey = ({
    organizationId,
    instanceId,
}: BuildOrganizationServiceDetailQueryKeyParams): OrganizationServiceDetailQueryKey => [
    ORGANIZATION_SERVICES_QUERY_KEY_ROOT,
    organizationId,
    instanceId,
];

export default buildOrganizationServiceDetailQueryKey;
